import Relations from '~/scripts/services/relations';
import Link from '~/scripts/services/model/link';

export default class ModalOoAdminLinkController {
	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {any} $scope
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {any} NodeService
	 * @param {import('~/scripts/services/model/link').default} link
	 * @param {any} edit
	 * @param {any} isaDefinedBy
	 */
	constructor(
		$injector,
		$scope,
		$translate,
		$uibModalInstance,
		NodeService,
		link,
		edit,
		isaDefinedBy,
	) {
		this.$injector = $injector;
		this.$scope = $scope;
		this.$translate = $translate;
		this.$uibModalInstance = $uibModalInstance;
		this.NodeService = NodeService;
		this.link = link;
		this.edit = edit;
		this.isaDefinedBy = isaDefinedBy;
		this.mfTarget = undefined;
		this.mfTargetCustom = false;
		this.mfTargetCustomKid = undefined;

		if (typeof link.order === 'string') {
			link.order = Number.parseInt(link.order, 10);
		}

		if (!this.link.linker_kid) {
			this.link.linker_kid = '0';
		}
		this.composedOf = null;
		this.card = {
			from: this.link.card_from,
			to:   this.link.card_to,
		};

		this.tmp = {
			card:       {
				from: this.card.from,
				to:   this.card.to,
			},
			objnum2:    edit && link.objnum2_kid ? [{ kid: link.objnum2_kid, name: link.objname }] : [],
		};

		(async () => {
			const relations = await Relations.get($injector);
			this.relations = relations.filter(relation => !NodeService.dynRelations().includes(relation.kid));
		})();

		if (this.link) {
			for (const l of this.isaDefinedBy) {
				if (this.link.class_kid === l.objnum2_kid) {
					this.setComposedOf(l);
				}
			}
		}

		this.$scope.$watch('$ctrl.tmp.card', (/** @type {{ from: number; to: number; }} */ card) => {
			if (card) {
				this.link.card_from = card.from;
				this.link.card_to = card.to;
			}
		}, true);
	}

	cancel() {
		this.composedOf = null;
		this.$uibModalInstance.dismiss('cancel');
	}

	save() {
		return this.$uibModalInstance.close({
			link: this.link,
			edit: this.edit,
			class_kid: this.composedOf ? this.composedOf.objnum2_kid : null,
		});
	}

	/**
	 * @param {any} l
	 */
	setComposedOf(l) {
		this.composedOf = l;
		this.setMfTarget(l);
	}

	/**
	 * @param {import('~/scripts/services/model/link').default | 'all' | 'custom'} l
	 */
	setMfTarget(l) {
		if (l === 'all') {
			this.mfTargetCustom = false;
			this.mfTarget = {
				kid: 'ALL',
				name: this.$translate.instant('common.all'),
			};
		}
		else if (l === 'custom') {
			this.mfTargetCustom = true;
			this.mfTarget = {
				kid: 'ALL',
				name: this.$translate.instant('common.all'),
			};
		}
		else {
			this.mfTargetCustom = false;
			this.mfTarget = l.objnum2_kid && l.objname ? {
				kid:  l.objnum2_kid,
				name: l.objname + (l.linker_kid === '0' ? '' : ` :: ${l.linker_info.name}`),
			} : undefined;
		}
	}

	/**
	 * @param {any} item
	 */
	setMfTargetFromCustom(item) {
		this.setMfTarget(new Link({
			objnum2_kid: item.kid,
			objname: item.name,
			linker_kid: '0',
		}));
	}

	/**
	 * @param {any} item
	 */
	setObjnum2(item) {
		if (item) {
			this.link.objname = item.name;
			this.link.isa = item.isa;
			this.link.isaname = item.isa_name;
		}
		else {
			this.link.objname = undefined;
			this.link.isa = undefined;
			this.link.isaname = undefined;
		}
	}
}
